import React, { FC, ChangeEvent } from "react";
import styled from "styled-components";

interface TextInputProps {
  boxWidth?: number;
  inputWidth: number;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onInput?: (e: React.FormEvent<HTMLInputElement>) => void;
  htmlFor?: string;
  labelName: string;
  name?: string;
  type: string;
  placeholder?: string;
  required?: boolean;
  maxLength?: number;
  margin?: string;
  value?: string;
  pattern?: undefined;
  appearance?: string;
  labelWidth?: number;
}
const InputBox = styled.div<{ boxWidth?: number; margin?: string }>`
  /* border: solid 1px; */
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: ${(props) => `${props.boxWidth}%`};
  margin-top: 12px;
  @media ${(props) => props.theme.device.laptop} {
    width: 100%;
  }
`;

const InputLabel = styled.label<{ labelWidth?: number }>`
  font-size: 20px;
  width: ${(props) => `${props.labelWidth}%`};
  color: #666;
  @media ${(props) => props.theme.device.laptop} {
    font-size: 16px;
    word-break: keep-all;
    min-width: 80px;
    width: 20%;
  }
  @media ${(props) => props.theme.device.mobile} {
    font-size: 12px;
    min-width: 50px;
  }
`;

const InputArea = styled.input<{ inputWidth?: number }>`
  width: ${(props) => `${props.inputWidth}%`};
  height: 40px;
  padding: 10px;
  box-sizing: border-box;
  border: 1px solid #dcdcdc;
  border-radius: 5px;
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  @media ${(props) => props.theme.device.laptop} {
    width: 80%;
  }
`;

const TextInput: FC<TextInputProps> = ({
  boxWidth,
  inputWidth,
  onChange,
  htmlFor,
  labelName,
  name,
  type,
  placeholder,
  required,
  maxLength,
  margin,
  value,
  pattern,
  labelWidth,
}) => {
  return (
    <InputBox boxWidth={boxWidth} margin={margin}>
      <InputLabel labelWidth={labelWidth} htmlFor={htmlFor}>
        {labelName}
      </InputLabel>
      <InputArea
        inputWidth={inputWidth}
        onChange={onChange}
        name={name}
        type={type}
        placeholder={placeholder}
        required={required}
        maxLength={maxLength}
        value={value}
        pattern={pattern}
      />
    </InputBox>
  );
};

export default TextInput;
